import { v4 as uuidv4 } from 'uuid';

import { MatchType } from '@frontend/types/workflow-agent';

/**
 * Generate a unique UUID for nodes
 */
export function generateNodeId(): string {
  return uuidv4();
}

/**
 * Generate a unique UUID for edges
 */
export function generateEdgeId(): string {
  return uuidv4();
}

/**
 * Generate a deterministic condition node ID based on parent step ID.
 *
 * Since there's only ONE condition node per conditional step (with multiple
 * outgoing edges carrying condition data), we use a simple suffix format.
 */
export function generateConditionNodeId(parentStepId: string): string {
  return `${parentStepId}-condition`;
}

/**
 * Simple string hash function for deterministic IDs.
 * Used for legacy condition node ID generation.
 */
function simpleHash(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash).toString(36).substring(0, 12);
}

/**
 * Generate a legacy condition node ID using the old hash-based format.
 * Used for backward-compatible rendering of old workflow executions.
 */
export function generateLegacyConditionNodeId(
  parentStepId: string,
  condition: { matching_condition: string; match_type: MatchType }
): string {
  const contentString = `${condition.match_type}:${condition.matching_condition}`;
  const hash = simpleHash(contentString);
  return `${parentStepId}-condition-${hash}`;
}
